/** @format */

import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ReactComponent as PageBannerSVG } from "../../../Assets/img/big-lkwb.svg";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import HTMLParser from "../../Components/HTMLParser";
import SEO from "../../Components/Seo/Seo";
import { allProducts } from "../../../Features/HomeApi/HomeSlice";
import Loader from "../../Components/Loader/Loader";

const BooksNotes = () => {
  const dispatch = useDispatch();

  // Fetch all products (books & notes)
  useEffect(() => {
    dispatch(allProducts());
  }, [dispatch]);

  // Destructure from Redux
  const { books_notes: booksnotes, isLoading } = useSelector(
    (state) => state.home?.allProduct || {},
  );

  // Show loader while fetching
  if (isLoading) {
    return (
      <div className="loading__mode bigLoading">
        <Loader />
      </div>
    );
  }

  // SEO dynamic description
  const seoTitle = "Books & Notes - LKWB";
  const seoDescription =
    booksnotes && booksnotes.length > 0 ?
      `Explore our collection of ${booksnotes.length} books and notes. Find the perfect resource for your studies and research.`
    : "Explore our collection of books and notes. Find the perfect resource for your studies and research.";

  return (
    <>
      {/* SEO */}
      <SEO title={seoTitle} description={seoDescription} path="/books-notes" />

      {/* Banner */}
      <div className="pageBanner">
        <PageBannerSVG />
        <Container>
          <div className="page-wrap">
            <h3>Books/Notes</h3>
          </div>
          <div className="custom-shape-divider-bottom-1678688493">
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1200 120"
              preserveAspectRatio="none"
            >
              <path
                d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                className="shape-fill"
              ></path>
            </svg>
          </div>
        </Container>
      </div>

      {/* Books Notes List */}
      <section className="section">
        {booksnotes && booksnotes.length > 0 ?
          <Container>
            <Row className="g-4">
              {booksnotes.map((item) => (
                <Col
                  key={item.id}
                  lg={4}
                  sm={6}
                  xs={12}
                  className="eachbooknote"
                >
                  <Link to={`/books-notes/booknotessingle/${item.id}`}>
                    <img src={item.image} alt={item.title} />
                  </Link>
                  <h3>
                    <Link to={`/books-notes/booknotessingle/${item.id}`}>
                      {item.title}
                    </Link>
                  </h3>
                  {item.description && (
                    <div className="description">
                      <HTMLParser>{item.description}</HTMLParser>
                    </div>
                  )}
                </Col>
              ))}
            </Row>
          </Container>
        : <Container>
            <div className="dashboard-contents">
              <p>Books and Packages are not available at the moment.</p>
            </div>
          </Container>
        }
      </section>
    </>
  );
};

export default BooksNotes;
